import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AiMessage, AiMessageCreate, AiMessageFilter } from '../data/aiMessage';

export function createAiMessageService(client: AxiosInstance) {
  return createCrudService<AiMessage, AiMessageCreate, AiMessageFilter>(
    client,
    '/ai/AiMessage',
    'id',
  );
}

export type AiMessageService = CrudService<AiMessage, AiMessageCreate, AiMessageFilter>;
